import { render, staticRenderFns } from "./Designs.vue?vue&type=template&id=287e9c86"
import script from "./Designs.vue?vue&type=script&lang=js"
export * from "./Designs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports